import { Link } from '../lib/router';

export default function PublicFooter() {
  return (
    <footer className="public-footer">
      <div className="public-footer-inner">
        <div>
          <strong>LoyalQR.sg</strong>
          <span>Made for Singapore businesses.</span>
        </div>
        <nav aria-label="Footer navigation">
          <Link to="/">Home</Link>
          <Link to="/resources">Resources</Link>
          <Link to="/contact">Contact us</Link>
          <Link to="/merchant/login">Business login</Link>
        </nav>
        <a href="mailto:loyalqr.sg@gmail.com">loyalqr.sg@gmail.com</a>
      </div>
    </footer>
  );
}
